import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export const distributorDomains = async opts => {
  const data = { show_all: true, state: opts?.state || undefined };
  const res = await HttpPromise({
    method: "GET",
    url: "/api/admin/distributor_email_domain_matches",
    data,
  });

  if (res) {
    return res;
  }
};

export const isValidDomain = (
  domain: string,
  distributorId: number,
  distributorDomainMatches: any[],
) => {
  const matchedDistributorDomains = distributorDomainMatches.filter(
    domainMatch => domainMatch.domain == domain,
  );
  if (matchedDistributorDomains.length) {
    let distributorIds = matchedDistributorDomains.map(domainMatch => domainMatch.distributor_id);
    if (!distributorIds.includes(distributorId)) {
      return false;
    }
  }
  return true;
};
